import styled from "styled-components";

const TableFilterDiv = styled.div`
    max-width: 855px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 40px;

    @media (max-width: 1023px) {
        flex-direction: column;
    }

    div {
        &:has(.dropdown-filter) {
            width: 100%;
        }

        &:has(.dropdown-filter.products) {
            max-width: 358px;
        }

        &:has(.dropdown-filter.years),
        &:has(.dropdown-filter.months) {
            max-width: 160px;
        }

        @media (max-width: 1023px) {
            &:has(.dropdown-filter.products),
            &:has(.dropdown-filter.years),
            &:has(.dropdown-filter.months) {
                max-width: 335px;
            }
        }
    }
    
    .dropdown-filter {
        height: 48px;
        padding-left: 18px;
        background-color: #FFFFFF;
        border: 1px solid #1A0242;

        &:focus-within, &:hover {
            border-color: #1A0242 !important;
        }

        .react-dropdown-select-content {
            font-size: 16px;
            line-height: 18px;
            font-weight: 400;
            color: #1A0242;
            font-family: "Eina01-Medium";

            .react-dropdown-select-input {
                width: 100%;
                margin: 0;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: none;

                &::placeholder {
                    font-size: 16px;
                    line-height: 18px;
                    font-weight: 400;
                    color: #1A0242;
                    font-family: "Eina01-Medium";
                }
            }
        }

        .react-dropdown-select-dropdown-handle {
            svg {
                width: 14px;
                height: auto;
                fill: #1A0242;
                transform: scale(2);
            }

            &:hover {
                svg {
                    path {
                        stroke: none;
                    }
                }
            }
        }

        &[aria-expanded='false'] {
            .react-dropdown-select-dropdown-handle {
                width: 90%;
                text-align: start;
                position: absolute;
                right: 20px;
            }
        }

        &[aria-expanded='true'] {
            .react-dropdown-select-dropdown-handle {
                width: 90%;
                text-align: end;
                position: absolute;
                right: 20px;
            }
        }

        .react-dropdown-select-dropdown {
            width: 100%;
            max-height: 150px;
            top: 105%;
            left: 0;
            border-left: 1px solid #1A0242;
            border-right: 1px solid #1A0242;
            border-bottom: 1px solid #1A0242;
            font-size: 16px;
            line-height: 18px;
            font-weight: 400;
            color: #1A0242 !important;
            font-family: "Eina01-Medium";

            .react-dropdown-select-item {
                padding: 5px 18px;
            }
        }
    }

    a.search-button {
        display: flex;
        align-items: center;
        width: 121px;
        height: 48px;
        background: #D4FC00;
        padding: 0 18px;
        margin: 0;
        border: none;
        cursor: pointer;
        font-size: 15px;
        line-height: 16px;
        font-weight: 400;
        color: #1A0242;
        font-family: "Eina01-Bold";
        text-transform: uppercase;
        text-decoration: none;
        transition: all ease-in-out 0.3s;

        &:hover {
            background: #1A0572;
            color: #D4FC00;
        }

        @media (max-width: 1023px) {
            max-width: 335px;
            width: 100%;
            margin: 0;
            justify-content: center;
        }
    }    
`;

const FilterBottomMessage = styled.div`
    width: 100%;
    padding: 0 20px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;

    span {
        width: 855px;
        font-weight: 400;
        font-size: 16px;
        line-height: 18px;
        color: #FFFFFF;
        font-family: "Eina01-Medium";

        &#filter-bottom-unity {
            width: fit-content;
            text-transform: uppercase;
        }
    }
`;

export {
    TableFilterDiv,
    FilterBottomMessage
}